import React from 'react';
import TrackList from "../Tracklist/TrackList";
import './Playlist.css';

function Playlist({tracks , onRemove, playlistName, handleChange, saveToSpotify, }) {


    return (
        <div className="Playlist">
            <form>
                <input
                    value={playlistName}
                    type='text'
                    onChange={(e) => handleChange(e.target.value)}
                    placeholder='Playlist Name'
                />
            </form>
            <TrackList tracks={tracks} isRemoveable={true} onRemove={onRemove} />
            <button id='buttonSpotify' type='submit' onClick={() => {saveToSpotify();  }}>Save to spotify</button>
        </div>
    );
}

export default Playlist;